"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));

var _reactI18next = require("react-i18next");

var _getusermedia = _interopRequireDefault(require("getusermedia"));

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

var _ImageFile = _interopRequireWildcard(require("./ImageFile"));

var _VideoFile = _interopRequireWildcard(require("./VideoFile"));

var _AudioFile = _interopRequireWildcard(require("./AudioFile"));

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _file = require("../../utils/file");

var _allowFileExtensions = require("../../constants/allowFileExtensions");

var _validation = require("../../utils/validation");

var _MEDIA, _MODAL_CONTENT, _BTN_TEXT;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};
var formStyles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};
var FILE_TYPES = {
  image: 'image',
  video: 'video',
  audio: 'audio',
  document: 'document'
};
var MEDIA = (_MEDIA = {}, (0, _defineProperty2["default"])(_MEDIA, FILE_TYPES.audio, {
  audio: true
}), (0, _defineProperty2["default"])(_MEDIA, FILE_TYPES.video, {
  audio: true,
  video: true
}), (0, _defineProperty2["default"])(_MEDIA, FILE_TYPES.image, {
  video: true
}), _MEDIA);
var MODAL_CONTENT = (_MODAL_CONTENT = {}, (0, _defineProperty2["default"])(_MODAL_CONTENT, FILE_TYPES.audio, _AudioFile["default"]), (0, _defineProperty2["default"])(_MODAL_CONTENT, FILE_TYPES.video, _VideoFile["default"]), (0, _defineProperty2["default"])(_MODAL_CONTENT, FILE_TYPES.image, _ImageFile["default"]), _MODAL_CONTENT);
var BTN_TEXT = (_BTN_TEXT = {}, (0, _defineProperty2["default"])(_BTN_TEXT, FILE_TYPES.audio, 'recordAudio'), (0, _defineProperty2["default"])(_BTN_TEXT, FILE_TYPES.video, 'recordVideo'), (0, _defineProperty2["default"])(_BTN_TEXT, FILE_TYPES.image, 'takePhoto'), _BTN_TEXT);

var File = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(File, _Component);

  var _super = _createSuper(File);

  function File() {
    var _this;

    (0, _classCallCheck2["default"])(this, File);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      loading: false,
      error: false,
      available: false,
      visibleModal: false,
      fileNames: {}
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSave", function (file) {
      if (file) {
        var _this$props = _this.props,
            postFileUrl = _this$props.postFileUrl,
            settings = _this$props.settings,
            getFileUrl = _this$props.getFileUrl,
            _this$props$input = _this$props.input,
            value = _this$props$input.value,
            name = _this$props$input.name,
            onChange = _this$props.onChange,
            t = _this$props.t,
            allowFileExtensions = _this$props.allowFileExtensions,
            setInputError = _this$props.setInputError;
        var multiple = (0, _ramda.prop)('multiple', settings);
        var type = (0, _ramda.prop)('type', settings);
        var fd = new FormData();
        var fileExtenstion = (0, _ramda.last)("".concat(file.name).split('.'));
        var fileType = file.type || (0, _ramda.path)([type, fileExtenstion], _allowFileExtensions.defaultAllowFileExtensions);
        var validFileType = (0, _validation.checkFileType)(type, file.type, fileExtenstion, allowFileExtensions);
        fd.append('file', file, file.name);
        fd.append('name', file.name);

        if (validFileType) {
          _this.setState({
            loading: true,
            error: false
          });

          setInputError(undefined);
          fetch(postFileUrl, {
            method: 'POST',
            body: fd
          }).then(function (response) {
            if (!response.ok && response.status !== 400) {
              throw new Error();
            } else {
              return response.json();
            }
          }).then(function (data) {
            var name = _this.props.input.name;
            var fileName = data.filename;

            if (data.statusCode === 400) {
              setInputError((0, _file.getFileErrorText)(data.message));
              return _this.setState({
                error: data.message || true,
                loading: false
              });
            }

            if (!data.id) {
              return _this.setState({
                error: true,
                loading: false
              });
            }

            var url = getFileUrl ? getFileUrl(data.id) : data.id;

            _this.setState({
              loading: false
            });

            var fileItem = {
              url: url,
              text: fileName,
              extenstion: fileExtenstion,
              contentType: fileType,
              type: type
            };

            if (multiple) {
              var fieldFiles = (0, _ramda.pathOr)([], ['fileNames', name], _this.state);

              _this.setState({
                fileNames: (0, _defineProperty2["default"])({}, name, [].concat((0, _toConsumableArray2["default"])(fieldFiles), [fileName]))
              });

              onChange((0, _ramda.append)(fileItem, value || []));
            } else {
              _this.setState({
                fileNames: (0, _defineProperty2["default"])({}, name, [fileName])
              });

              onChange(fileItem);
            }
          })["catch"](function (error) {
            setInputError((0, _file.getFileErrorText)(error));

            _this.setState({
              error: true
            });
          });
        } else {
          var fileItem = {
            text: file.name,
            extenstion: fileExtenstion,
            contentType: fileType,
            type: type
          };
          setInputError((0, _validation.getFileTypeMessage)(type, allowFileExtensions));

          if (multiple) {
            var fieldFiles = (0, _ramda.pathOr)([], ['fileNames', name], _this.state);

            _this.setState({
              error: true,
              fileNames: (0, _defineProperty2["default"])({}, name, [].concat((0, _toConsumableArray2["default"])(fieldFiles), [fileItem.text]))
            });

            onChange((0, _ramda.append)(fileItem, value || []));
          } else {
            _this.setState({
              error: true,
              fileNames: (0, _defineProperty2["default"])({}, name, [fileItem.text])
            });

            onChange(fileItem);
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (e) {
      var file = e.target.files[0];

      _this.onSave(file);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDelete", function (index) {
      var _this$props2 = _this.props,
          _this$props2$input = _this$props2.input,
          value = _this$props2$input.value,
          name = _this$props2$input.name,
          setInputError = _this$props2.setInputError,
          onChange = _this$props2.onChange;
      var fieldFiles = (0, _ramda.path)(['fileNames', name], _this.state);
      setInputError(undefined);

      _this.setState({
        error: false,
        fileNames: (0, _defineProperty2["default"])({}, name, (0, _ramda.remove)(index, 1, fieldFiles))
      });

      if (Array.isArray(value)) {
        var newFieldValue = (0, _ramda.remove)(index, 1, value);
        onChange((0, _ramda.isEmpty)(newFieldValue) ? undefined : newFieldValue);
      } else {
        onChange(undefined);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openModal", function () {
      if (!_this.state.available) {
        var _ref = _this.props.settings || {},
            type = _ref.type;

        (0, _getusermedia["default"])(MEDIA[type], function (error, stream) {
          if (error) {
            _this.setState({
              visibleModal: true
            });
          } else {
            _this.stream = stream;

            _this.setState({
              visibleModal: true,
              available: true
            });
          }
        });
      } else {
        _this.setState({
          visibleModal: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeModal", function () {
      if (_this.stream) {
        _this.stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }

      _this.setState({
        visibleModal: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSaveModalContent", function (file) {
      _this.onSave(file);

      _this.closeModal();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPreview", function (url, index, type) {
      var name = _this.props.input.name;
      var fileName = (0, _ramda.path)(['fileNames', name, index], _this.state);
      var isBlob = fileName === 'blob' || fileName === _ImageFile.IMAGE_WEB_NAME || fileName === _VideoFile.VIDEO_WEB_NAME || fileName === _AudioFile.AUDIO_WEB_NAME;

      switch (type) {
        case FILE_TYPES.image:
          return /*#__PURE__*/_react["default"].createElement("div", null, isBlob ? /*#__PURE__*/_react["default"].createElement("img", {
            className: styles.imagePreview,
            src: url,
            alt: "file"
          }) : fileName);

        case FILE_TYPES.video:
          return /*#__PURE__*/_react["default"].createElement("div", null, isBlob ? /*#__PURE__*/_react["default"].createElement("video", {
            key: url,
            height: 200,
            controls: true
          }, /*#__PURE__*/_react["default"].createElement("source", {
            src: url,
            type: "video/webm"
          })) : fileName);

        case FILE_TYPES.audio:
          return /*#__PURE__*/_react["default"].createElement("div", null, isBlob ? /*#__PURE__*/_react["default"].createElement("audio", {
            controls: true,
            key: url
          }, /*#__PURE__*/_react["default"].createElement("source", {
            src: url
          })) : fileName);

        default:
          return /*#__PURE__*/_react["default"].createElement("div", null, fileName);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getAccept", function (type) {
      var allowFileExtensions = _this.props.allowFileExtensions;

      if (allowFileExtensions) {
        return allowFileExtensions[type] ? ".".concat((0, _ramda.join)(', .', (0, _ramda.keys)(allowFileExtensions[type]))) : _allowFileExtensions.TYPES[type];
      } else {
        return _allowFileExtensions.TYPES[type];
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(File, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          settings = _this$props3.settings,
          _this$props3$input = _this$props3.input,
          value = _this$props3$input.value,
          name = _this$props3$input.name,
          t = _this$props3.t,
          disabled = _this$props3.disabled;

      var _ref2 = settings || {},
          type = _ref2.type,
          multiple = _ref2.multiple;

      var values = value ? multiple ? value : [value] : [];
      var ModalContent = MODAL_CONTENT[type];
      var _this$state = this.state,
          loading = _this$state.loading,
          error = _this$state.error;
      var isLoading = loading && !error;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(name, "-file")
      }, !(0, _ramda.isEmpty)(value) && /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.fileList
      }, values.map(function (_ref3, index) {
        var url = _ref3.url;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.fileItem,
          key: "file-".concat(index)
        }, _this2.renderPreview(url, index, type), /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.fileButtonGroup
        }, !!url && /*#__PURE__*/_react["default"].createElement("a", {
          className: "".concat(styles.downloadButton, " ").concat(disabled ? styles.downloadButtonDisabled : ''),
          href: disabled ? undefined : url,
          download: true,
          target: "_blank",
          rel: "noopener noreferrer"
        }, t('download')), /*#__PURE__*/_react["default"].createElement("button", {
          disabled: disabled,
          className: "".concat(styles.dangerBtn, " ").concat(disabled ? styles.dangerBtnDisabled : ''),
          type: "button",
          onClick: function onClick() {
            return _this2.onDelete(index);
          }
        }, t('remove'))));
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.fileControls
      }, !multiple && value.length > 1 ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
        className: styles.fileInput,
        id: name,
        type: "file",
        value: "",
        onChange: this.onChange,
        accept: this.getAccept(type),
        disabled: disabled || isLoading
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: name,
        className: "".concat(disabled ? 'disabled' : '')
      }, isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null), /*#__PURE__*/_react["default"].createElement("span", {
        className: "button-text"
      }, t('upload')))), !multiple && value.length > 1 || !BTN_TEXT[type] ? null : type && /*#__PURE__*/_react["default"].createElement("button", {
        disabled: isLoading || disabled,
        className: formStyles.formBtn,
        type: "button",
        onClick: this.openModal
      }, t(BTN_TEXT[type]))), MODAL_CONTENT[type] && /*#__PURE__*/_react["default"].createElement(_reactResponsiveModal["default"], {
        center: true,
        open: this.state.visibleModal,
        onClose: this.closeModal,
        classNames: {
          modal: 'modal file-modal',
          closeButton: 'modalCloseButton'
        }
      }, /*#__PURE__*/_react["default"].createElement(ModalContent, {
        key: this.state.available,
        available: this.state.available,
        onChange: this.onSaveModalContent
      })));
    }
  }]);
  return File;
}(_react.Component);

var _default = (0, _withFieldWrapper["default"])((0, _reactI18next.withTranslation)()(File));

exports["default"] = _default;